import { useFeatureNamesData } from "@/feature/data/useFeatureNamesData";
import { FeatureName } from "@reflag/shared/featureAPI";
import { getFeatureParentNames } from "@reflag/shared/utils/getFeatureParentNames";

export function useFeatureParentNames(featureId?: string): Array<FeatureName> {
  const { data: features, isSuccess } = useFeatureNamesData();

  if (!isSuccess || !featureId) {
    return [];
  }

  return getFeatureParentNames(features, featureId);
}
